import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Rate, Row, Tooltip, message } from 'antd';
import Cookies from 'js-cookie';
import QuotationModal from './modal/quatationModal';
import PaymentModal from './modal/paymentModal';
import expertIcon from '../../assets/images/profile_placeholder.png';

import { AssignQuestionToExpertModal } from './modal/assignToModal';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestRejectModal } from './modal/requestRejectModal';
import {
  breakName,
  createMarkup,
  getExpertiyInIndustery,
  getRanksOfExperts,
  role,
} from '../../helpers/functions';
import useResponsive from '../../hooks/useBreakpoint';
import WhatsNextModal from './modal/WhatsNextModal';
import { nameRecommendationConstantForToolTip, ROLE_NAME } from '../../helpers/constant';
import Circleprogress from './circleprogress';
import paymentInfoIcon from '../../assets/images/paymentInfoIcon.jpeg';
import messageIcon from '../../assets/images/whats_next_message.png';
import bookIcon from '../../assets/images/whats_next_book.png';
import qotationIcon from '../../assets/images/QuotationIconNew.png';
import acceptIcon from '../../assets/images/whats_next_accept.png';
import otherIcon from '../../assets/images/whats_next_search.png';
import Loader from './Loader';
import AddMeetingTime from './modal/addMeetingTime';
import TextDisplayModal from './TextDisplayModal';
import { postRequestAPI } from '../../helpers/service';

export const AssignedToExpertCard = ({ data, setSelectedTab }) => {
  const dispatch = useDispatch();
  const [quotationModal, setQuotationModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [requestRejectModal, setRequestRejectModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(null);
  const [showFullProposal, setShowFullProposal] = useState(false);
  const [showWhatsNextModal, setShowWhatsNextModal] = useState(false);
  const [dontShowWhatsNext, setDontShowWhatsNext] = useState(false);
  const [proposalModal, setProposalModal] = useState(false);
  const [proposalLoading, setProposalLoading] = useState(false);
  const [proposal, setProposal] = useState(data?.proposal);

  const [ranks, setRanks] = useState(null);
  const navigate = useNavigate();
  const proposalLimit = 500;
  const { isDontShowWhatsNext } = useSelector(state => state.common);
  const [infoModel, setInfoModel] = useState(false);
  const state = useSelector(state => state);
  const { threadBySubjectId } = useSelector(state => state.requests);
  useEffect(() => {
    if (role() != ROLE_NAME.ADMIN) {
      dispatch({ type: 'RECOMMENDED_EXPERT_LIST_REQUEST', questionId: data?.status?.question_id });
    }
  }, [data?.status?.question_id]);
  useEffect(() => {
    if (state?.expert?.recommendedExpertsList?.length > 0 && showAssignModal == null) {
      setRanks(getRanksOfExperts(state?.expert?.recommendedExpertsList, data?.expert?.id));
    } else {
      setRanks(ranks);
    }
  }, [state?.expert?.recommendedExpertsList.length, data?.status?.question_id]);

  useEffect(() => {
    if (!Cookies.get(`dontShowWhatsNext_${data?.user?.id}`)) {
      dispatch({ type: 'GET_DONT_SHOW_WHATS_NEXT_MODAL', userId: data?.user?.id });
    }
    if (isDontShowWhatsNext) {
      Cookies.set(`dontShowWhatsNext_${data?.user?.id}`, 'true', { expires: 365 });
    }
    const dontShowWhatsNext = Cookies.get(`dontShowWhatsNext_${data?.user?.id}`);
    if (!dontShowWhatsNext) {
      setDontShowWhatsNext(true);
    }
  }, [showAssignModal]);

  const handleExpertRequestAccept = () => {
    dispatch({
      type: 'POST_CLIENT_ACCEPT_OR_REJECT_EXPERT_REQUEST',
      formData: { question_id: data?.id, is_approve: 1 },
    });
  };

  const handleCloseModal = () => {
    if (dontShowWhatsNext) {
      setShowWhatsNextModal(true);
    }
  };

  const parseProposal = proposal => {
    if (data?.status?.question_status?.status_order >= 7) {
      return proposal;
    } else {
      let fullName = data?.expert?.first_name + ' ' + data?.expert?.last_name;
      let updatedProposal = proposal.replace(
        new RegExp(fullName, 'g'),
        breakName(data?.expert?.first_name, data?.expert?.last_name),
      );
      updatedProposal = updatedProposal.replace(/\n{2,}/g, '\n');
      return updatedProposal;
    }
  };

  async function getEvalReport() {
    try {
      setProposalLoading(true);
      const response = await postRequestAPI({
        url: `get-proposal-for-expert`,
        data: { question_id: data.id, expert_id: data?.expert?.id },
      });
      if (response.status === 200) {
        setProposal(response?.data?.generatedText || '');
        setProposalLoading(false);
        setProposalModal(true);
      }
    } catch (error) {
      setProposalLoading(false);
    }
  }

  const breakpoint = useResponsive();
  const [bookButtonAssignToExpertCard, setBookButtonAssignToExpertCard] = useState(false);

  return (
    <div className="request-assigned-to-container">
      {data?.status?.question_status_id === 2 && data?.assign_by_admin === 0 ? (
        <h3>Find another expert</h3>
      ) : (
        <h3>We recommend</h3>
      )}

      {data?.status?.question_status?.status_order <= 9 && (
        <Row className="assigned-to-profile-container">
          {data?.status?.question_status_id === 2 && data?.assign_by_admin === 0 ? (
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} style={{ maxWidth: '70%' }}>
              Unfortunately, the expert you previously selected has rejected your request. Please
              select a different expert to assist you.
            </Col>
          ) : (
            <>
              <Col
                xs={24}
                sm={24}
                md={8}
                lg={8}
                xl={6}
                xxl={6}
                className="assigned-to-profile-left-container"
                onClick={() => navigate(`/find-expert-detail/${data?.expert?.id}`)}
              >
                <div className="assigned-to-profile-icon">
                  <img
                    alt="expert"
                    height={60}
                    width={60}
                    src={data?.expert_meta?.avatar ? data?.expert_meta?.avatar : expertIcon}
                    loading="lazy"
                  />
                </div>
                <div className="assigned-to-profile-detail " style={{ alignItems: 'center' }}>
                  <div className="assigned-to-profile-name">
                    {data?.status?.question_status?.status_order >= 7 ? (
                      data?.expert?.first_name + ' ' + data?.expert?.last_name
                    ) : (
                      <Tooltip
                        title={nameRecommendationConstantForToolTip?.title || ''}
                        color={nameRecommendationConstantForToolTip?.color}
                      >
                        {breakName(data?.expert?.first_name, data?.expert?.last_name)}
                      </Tooltip>
                    )}
                  </div>
                  <div className="assigned-to-profile-role">{data?.category?.name}</div>
                  <div>
                    <Button
                      type="primary"
                      size='small'
                      onClick={e => {
                        e.stopPropagation();
                        getEvalReport();
                      }}
                    >
                      Ai Evaluatation
                    </Button></div>
                </div>
              </Col>
            </>
          )}

          {data?.question_review?.length &&
            (data?.status?.question_status_id === 10 || data?.status?.question_status_id === 11) ? (
            <Col
              xs={24}
              sm={24}
              md={16}
              lg={16}
              xl={16}
              xxl={16}
              className="assigned-to-rating-container"
            >
              <div className="assigned-to-rating-container-div">My Review</div>
              <Rate disabled value={data?.question_review[0]?.rating} />
            </Col>
          ) : null}

          <Col
            xs={24}
            sm={24}
            md={16}
            lg={16}
            xl={18}
            xxl={18}
            style={{
              height: 'auto',
              width: '100%',
              display: 'flex',
              justifyContent: 'space-evenly',
            }}
            className="assigned-to-profile-button-group"
          >
            <Row
              style={{
                // backgroundColor: 'yellow',
                height: 'auto',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'start',
              }}
            >
              {' '}
              {/* {data?.status?.question_status_id !== 10 &&
              data?.status?.question_status_id !== 11 &&
              data?.status?.question_status_id < 4 &&
              data?.assign_by_admin === 0 ? (
                 <Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={5} style={{padding:"0.5rem"}}>
                  <Button
                    className="assigned-to-profile-button"
                    type="primary"
                    onClick={() => setShowAssignModal(true)}
                  >
                    Find Another1
                  </Button>
                </Col>
              ) : null}{' '} */}
              {data?.status?.question_status_id !== 10 &&
                data?.status?.question_status_id !== 11 &&
                // data?.status?.question_status_id < 4 &&
                data?.assign_by_admin === 1 &&
                data?.expert_approved !== 1 ? (
                <>
                  <Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={5} style={{ padding: '0.5rem' }}>
                    <Tooltip
                      title={`Accept our recommendation and ${breakName(data?.expert?.first_name, data?.expert?.last_name)} will contact you shortly`}
                      color="#1c64f2"
                    >
                      <Button
                        className="assigned-to-profile-button"
                        type={data?.expert_approved === 1 ? 'default' : 'primary'}
                        style={{
                          backgroundColor: 'white',
                          border: '1px solid #1c64f2',
                          color: '#1c64f2',
                          display: 'flex',
                          flexDirection: 'column',
                          padding: '0.5rem',

                          minWidth: '100%',
                        }}
                        disabled={data?.expert_approved === 1}
                        onClick={() => {
                          if (data?.expert_approved === 0) {
                            handleExpertRequestAccept();
                          } else {
                            message.error('Waiting for expert approval.');
                          }
                        }}
                        size={breakpoint === 'xs' ? 'small' : 'default'}
                      >
                        <img width={20} height={20} src={acceptIcon} />
                        Accept
                      </Button>
                    </Tooltip>
                  </Col>
                </>
              ) : null}{' '}
              {setSelectedTab && (
                <Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={5} style={{ padding: '0.5rem' }}>
                  <Tooltip
                    title={`Start chatting with  ${breakName(data?.expert?.first_name, data?.expert?.last_name)} to ask any questions or clarify concerns before accepting`}
                    color="#1c64f2"
                  >
                    <Button
                      className="assigned-to-profile-button"
                      style={{
                        backgroundColor: 'white',
                        border: '1px solid #1c64f2',
                        color: '#1c64f2',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: '0.5rem',

                        minWidth: '100%',
                      }}
                      onClick={() => {
                        setSelectedTab('messaging');
                        window.scrollTo({
                          top: document.body.scrollHeight,
                          behavior: 'smooth',
                        });
                      }}
                      size={breakpoint === 'xs' ? 'small' : 'default'}
                    >
                      {/* Messaging */}
                      <img width={20} height={20} src={messageIcon} />
                      Message
                    </Button>
                  </Tooltip>
                </Col>
              )}{' '}
              {setSelectedTab && (
                <Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={5} style={{ padding: '0.5rem' }}>
                  <Tooltip
                    title={`Take a discussion further by booking a virtual meeting with  ${breakName(data?.expert?.first_name, data?.expert?.last_name)} to learn more before you proceed further`}
                    color="#1c64f2"
                  >
                    {
                      <div style={{ display: 'none' }}>
                        <AddMeetingTime
                          threadBySubjectId={threadBySubjectId}
                          bookButtonAssignToExpertCard={bookButtonAssignToExpertCard}
                          setBookButtonAssignToExpertCard={setBookButtonAssignToExpertCard}
                        />
                      </div>
                    }
                    <Button
                      className="assigned-to-profile-button"
                      style={{
                        backgroundColor: 'white',
                        border: '1px solid #1c64f2',
                        color: '#1c64f2',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: '0.5rem',

                        minWidth: '100%',
                      }}
                      onClick={() => {
                        setBookButtonAssignToExpertCard(true);
                        console.log('bookButtonAssignToExpertCard', bookButtonAssignToExpertCard);
                      }}
                      size={breakpoint === 'xs' ? 'small' : 'default'}
                    >
                      <img width={20} height={20} src={bookIcon} />
                      Book
                    </Button>
                  </Tooltip>
                </Col>
              )}{' '}
              {data?.status?.question_status_id !== 10 &&
                data?.status?.question_status_id !== 11 &&
                // data?.status?.question_status_id < 4 &&
                data?.assign_by_admin === 1 &&
                data?.expert_approved !== 1 ? (
                <>
                  <Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={5} style={{ padding: '0.5rem' }}>
                    <Tooltip
                      title={`Access the full list of experts, compare profiles, and choose the one that best fits your needs`}
                      color="#1c64f2"
                    >
                      <Button
                        className="assigned-to-profile-button"
                        danger
                        disabled={data?.expert_approved === 1}
                        onClick={() => {
                          if (data?.expert_approved === 0) {
                            setShowAssignModal(true);
                          } else {
                            message.error('Waiting for expert approval.');
                          }
                        }}
                        style={{
                          backgroundColor: 'white',
                          border: '1px solid #1c64f2',
                          color: '#1c64f2',
                          display: 'flex',
                          flexDirection: 'column',
                          padding: '0.5rem',

                          minWidth: '100%',
                        }}
                        size={breakpoint === 'xs' ? 'small' : 'default'}
                      >
                        <img width={20} height={20} src={otherIcon} />
                        Other Options
                      </Button>
                    </Tooltip>
                  </Col>
                </>
              ) : null}{' '}
              {data?.status?.question_status_id !== 10 &&
                data?.status?.question_status_id !== 11 &&
                data?.status?.question_status_id < 4 &&
                data?.assign_by_admin === 0 ? (
                <Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={5} style={{ padding: '0.5rem' }}>
                  <Button
                    className="assigned-to-profile-button"
                    type="primary"
                    onClick={() => setShowAssignModal(true)}
                    style={{
                      backgroundColor: 'white',
                      border: '1px solid #1c64f2',
                      color: '#1c64f2',
                      display: 'flex',
                      flexDirection: 'column',
                      padding: '0.5rem',

                      minWidth: '100%',
                    }}
                    size={breakpoint === 'xs' ? 'small' : 'default'}
                  >
                    <img width={20} height={20} src={otherIcon} />
                    Find Another
                  </Button>
                </Col>
              ) : null}{' '}
              {data?.status?.question_status_id === 5 && (
                <Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={5} style={{ padding: '0.5rem' }}>
                  <Button
                    className="assigned-to-profile-button"
                    type="primary"
                    onClick={() => setQuotationModal(true)}
                    style={{
                      backgroundColor: 'white',
                      border: '1px solid #1c64f2',
                      color: '#1c64f2',
                      display: 'flex',
                      flexDirection: 'column',
                      padding: '0.5rem',

                      minWidth: '100%',
                    }}
                    size={breakpoint === 'xs' ? 'small' : 'default'}
                  >
                    <img width={20} height={20} src={qotationIcon} />
                    Quotation
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      )}

      <div style={{ item: 'left' }}>
        <Row
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: !(breakpoint === 'xs' || breakpoint === 'sm') && 'left',
            gap: '10px',
            width: '100%',
            // maxWidth: '100%',
            // borderBottom: '1px solid #ee2525ff',
          }}
        >
          {ranks ? (
            <>
              {/* expert?.category?.map(cat => cat.name).join(', '), */}
              {getExpertiyInIndustery(ranks[3] || 0) > 0 && (
                <Col xs={8} sm={6} md={3}>
                  <Tooltip
                    title={
                      data?.sector?.industry?.reduce?.(
                        (total, exp) => total + (exp.number_of_years || 0),
                        0,
                      ) || ''
                    }
                    placement="top"
                  >
                    <div>
                      <Circleprogress
                        percentage={getExpertiyInIndustery(ranks[3] || 0)}
                        heading="Experience"
                        info={{
                          perfect:
                            'Extensive hands-on experience in the field with consistent, proven results.',
                          moderate:
                            'Solid track record with increasing responsibility and results over time.',
                          unsure: 'Some familiarity or early-stage exposure to the field.',
                        }}
                      />
                    </div>
                  </Tooltip>
                </Col>
              )}
              {(ranks[1] || 0) > 0 && (
                <Col xs={8} sm={6} md={3}>
                  <Tooltip title={data?.sub_category?.name} placement="top">
                    <div>
                      <Circleprogress
                        percentage={ranks[1] || 0}
                        heading={'Service Type'}
                        sub_category={data?.sub_category?.name}
                        info={{
                          perfect: `Deep expertise in ${data?.sub_category?.name || 'subcategory'}.`,
                          moderate: `Experience in ${data?.sub_category?.name || 'subcategory'}.`,
                          unsure: `Limited exposure in ${data?.sub_category?.name || 'subcategory'}.`,
                        }}
                      />
                    </div>
                  </Tooltip>
                </Col>
              )}
              {(ranks[0] || 0) > 0 && (
                <Col xs={8} sm={6} md={3}>
                  <Tooltip title={data?.category?.name ?? 'Industry'} placement="top">
                    <div>
                      <Circleprogress
                        percentage={ranks[0] || 0}
                        heading="industry"
                        info={{
                          perfect: 'Extensive experience specific to the industry.',
                          moderate: 'Proven track record in related industries.',
                          unsure: 'Some familiarity with the industry.',
                        }}
                      />
                    </div>
                  </Tooltip>
                </Col>
              )}
              {(ranks[6] || 0) > 0 && (
                <Col xs={8} sm={6} md={3}>
                  <Tooltip title={data?.question_review?.rating || 'Reviews'} placement="top">
                    <div>
                      <Circleprogress
                        percentage={ranks[6] || 0}
                        heading="Reviews"
                        info={{
                          perfect: 'Consistently outstanding reviews.',
                          moderate: 'Mostly positive reviews with minor issues.',
                          unsure: 'Mixed reviews or limited feedback available.',
                        }}
                      />
                    </div>
                  </Tooltip>
                </Col>
              )}

              {(ranks[5] || 0) > 0 && (
                <Col xs={8} sm={6} md={3}>
                  <Tooltip title={data ? data?.location?.name : 'Location'} placement="top">
                    <div>
                      <Circleprogress
                        percentage={ranks[5] || 0}
                        heading="Location"
                        info={{
                          perfect: 'Located in the same province.',
                          moderate: 'Located in a neighboring province.',
                          unsure: 'Located in a different region of Canada.',
                        }}
                      />
                    </div>
                  </Tooltip>
                </Col>
              )}
              {(ranks[7] || 0) > 0 && (
                <Col xs={8} sm={6} md={3}>
                  <Tooltip title={data ? data?.language?.name : 'Language'} placement="top">
                    <div>
                      <Circleprogress
                        percentage={ranks[7] || 0}
                        heading="Language"
                        info={{
                          perfect: 'Communicate in one or more of your other language(s).',
                          moderate: 'pending',
                          unsure: 'Do not communicate in your other language(s).',
                        }}
                      />
                    </div>
                  </Tooltip>
                </Col>
              )}
              {(ranks[8] || 0) > 0 && (
                <Col xs={8} sm={6} md={3}>
                  <Tooltip title={`${ranks[8] || 0}`} placement="top">
                    <div>
                      <Circleprogress
                        percentage={ranks[8] || 0}
                        heading="Availability"
                        info={{
                          perfect: 'High availability; more time to dedicate to new clients.',
                          moderate: 'Moderate availability; balancing other clients.',
                          unsure: 'Limited availability; minimal time for new clients.',
                        }}
                      />
                    </div>
                  </Tooltip>
                </Col>
              )}
            </>
          ) : (
            <Col xs={24} style={{ textAlign: 'center' }}>
              <Loader />
            </Col>
          )}
        </Row>
      </div>

      {proposal ? (
        <div style={{ 'max-height': '100%' }}>
          <pre className="assigned-to-profile-proposal mt-4">
            {proposal?.length > proposalLimit && !showFullProposal ? (
              <span
                className="request-span"
                dangerouslySetInnerHTML={createMarkup(
                  parseProposal(proposal).slice(0, proposalLimit) + '...',
                )}
              />
            ) : (
              <span
                className="request-span"
                dangerouslySetInnerHTML={createMarkup(parseProposal(proposal))}
              />
            )}
          </pre>
          {proposal?.length > proposalLimit ? (
            <Button onClick={() => setShowFullProposal(val => !val)}>
              {showFullProposal ? 'Show less' : 'Show more'}
            </Button>
          ) : null}
        </div>
      ) : <>
      </>}

      {quotationModal && (
        <QuotationModal
          type="customer"
          open={quotationModal}
          close={() => setQuotationModal(false)}
          qid={data.id}
          questionData={data}
          openPayment={() => {
            setQuotationModal(false);
            setPaymentModal(true);
            setInfoModel(true);
          }}
        />
      )}
      {paymentModal && (
        <PaymentModal
          type="customer"
          open={paymentModal}
          close={() => setPaymentModal(false)}
          quotationId={data.quotation_detail !== null ? data?.quotation_detail?.id : ''}
          quotationDetail={data}
        />
      )}

      <AssignQuestionToExpertModal
        visible={showAssignModal}
        setVisible={setShowAssignModal}
        rowData={data}
        variant="client"
        onClose={handleCloseModal}
        onClickNeedHelp={setRequestRejectModal}
      />

      <WhatsNextModal
        visible={showWhatsNextModal}
        setVisible={setShowWhatsNextModal}
        userId={data?.user?.id}
        expertName={`${data?.expert?.first_name} ${data?.expert?.last_name}`}
      />
      <RequestRejectModal
        visible={requestRejectModal}
        setShowModal={setRequestRejectModal}
        rawData={data}
        variant="client"
      />

      <TextDisplayModal
        visible={proposalModal}
        setVisible={setProposalModal}
        content={proposal || ''}
        title={`${breakName(data?.expert?.first_name, data?.expert?.last_name)}'s Evaluation Report`}
      />

      <Modal
        title={null}
        open={infoModel}
        footer={
          <div>
            <Button
              type="primary"
              size="middle"
              className="mt5"
              onClick={() => setInfoModel(false)}
            >
              Got it
            </Button>
          </div>
        }
        closable={false}
        zIndex={10000}
        centered
      >
        <p style={{ fontSize: '18px', textAlign: 'center' }}>
          <div>
            <img
              loading="lazy"
              width={150}
              style={{ borderRadius: '50%' }}
              src={paymentInfoIcon}
              alt="Info"
            />
          </div>
          <p className="mt10">
            All payments are securely processed through Stripe. We do not store any payment
            information on our servers.
          </p>
        </p>
      </Modal>
    </div>
  );
};
